<script setup lang="ts">
import { type Option } from './primevue/select'

defineProps<{
  modelValue?: string
  options: Option[]
}>()

const emit = defineEmits(['update:modelValue'])

function select(value?: string) {
  emit('update:modelValue', value)
}
</script>

<template>
  <div class="flex gap-2">
    <Button
      class="flex-1 text-nowrap"
      v-for="option in options"
      :key="option.value"
      size="xs"
      :aria-pressed="option.value === modelValue"
      @click="select(option.value)"
      :variant="option.value === modelValue ? '' : 'outline'"
    >
      {{ option.label }}
    </Button>
  </div>
</template>
